import React from "react";
import { ChallengesProvider } from "../../contexts/Challenges";
import { OrganizersProvider } from "../../contexts/Organizers";
import { ChallengeContainer } from "../components/challenges/ChallengeContainer";

import Header, { pages } from "./Header";

export const ChallengePage = () => {
    return (
        <ChallengesProvider>
            <OrganizersProvider>
                <Header activePage={pages.CHALLENGES} />
                <ChallengeContainer/>
            </OrganizersProvider>
        </ChallengesProvider>
    );
};